"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stepTheme = exports.stepLabelTheme = exports.stepConnectorTheme = void 0;
var stepTheme = {
  root: {
    '&.clickable': {
      '&:hover': {
        cursor: 'pointer'
      }
    }
  }
};
exports.stepTheme = stepTheme;
var stepLabelTheme = {
  label: {
    '&$alternativeLabel': {
      textAlign: 'center',
      marginTop: 4
    }
  },
  labelContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  }
};
exports.stepLabelTheme = stepLabelTheme;

var stepConnectorTheme = function stepConnectorTheme(theme) {
  return {
    lineHorizontal: {
      borderTopWidth: 2,
      borderRadius: 2
    },
    line: {
      borderColor: theme.palette.divider
    },
    alternativeLabel: {
      top: 18
    }
  };
};

exports.stepConnectorTheme = stepConnectorTheme;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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